import { motion } from "framer-motion";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import NavBar from "../../components/home/navbar";
import ArrowDown from "../../components/icons/arrow-down";
import Icon from "../../components/icons/index";

const Home: React.FC = () => {
  const data = useStaticQuery(graphql`
    {
      site {
        buildTime(formatString: "YYYY-MM-DD hh:mm a z")
      }
      downArrow: file(relativePath: { eq: "arrow-down.svg" }) {
        publicURL
      }
      darkPhoto: file(relativePath: { eq: "me-d.png" }) {
        publicURL
      }
      lightPhoto: file(relativePath: { eq: "me-l.png" }) {
        publicURL
      }
    }
  `);

  return (
    <div className="h-full">
      <div className="grid grid-auto-flow grid-flow-row  main-min-h h-full rounded-lg shadow-md pb-4 ">
        <NavBar />
        <motion.div
          animate={{ scale: 1, opacity: 1 }}
          initial={{ scale: 0.7, opacity: 0 }}
          transition={{
            duration: 0.5,
            delay: 0.5 * 1,
          }}
          className="grid lg:grid-cols-2 my-image text-center"
        >
          <div className="flex self-center justify-center content-center pt-2">
            <img src={`${data.darkPhoto?.publicURL}`} />
          </div>
        </motion.div>

        {/* <div ref={animationContainer} /> */}

        <div className="lg:col-start-1 lg:row-start-3">
          <div className="grid grid-cols-7">
            <motion.div
              animate={{ y: 0, opacity: 1 }}
              initial={{ y: 30, opacity: 0 }}
              transition={{
                duration: 0.5,
                delay: 0.5 * 2,
              }}
              className="col-span-1 md:col-span-2  lg:col-span-4 content-center"
            >
              <hr className="mt-8 border-black" />
              <div className="p-1  ml-2 text-sm cv-download">
                <a target="_blank" href="../../doc/Anand_Ammathil_Resume.pdf">
                  Download CV
                </a>
              </div>
            </motion.div>
            <div className="pl-3 col-span-6 col-start-2 lg:col-start-5 md:col-start-3 lg:col-span-3">
              <div className="pr-10 text-justify">
                <motion.div
                  animate={{ opacity: 1 }}
                  initial={{ opacity: 0 }}
                  transition={{
                    duration: 0.5,
                    delay: 0.5 * 1,
                  }}
                  className="text-3xl"
                >
                  Hi, I'm Anand
                </motion.div>
                <motion.div
                  animate={{ y: 0, opacity: 1 }}
                  initial={{ y: 30, opacity: 0 }}
                  transition={{
                    duration: 0.5,
                    delay: 0.5 * 1,
                  }}
                  className=""
                >
                  <p className="pt-5">
                    I'm a guy with some coding skills. who love to architect,
                    code solutions and solving coding challenges. Started my
                    career as a freelancer during college. Currently working as
                    a Senior Software Engineer at Calo 💚, Dubai 🌤️
                  </p>
                  <p className="pt-1">
                    Most of the free times playing video games or solving
                    something on HackerRank®
                  </p>
                </motion.div>
                <motion.div
                  animate={{ y: 0, opacity: 1 }}
                  initial={{ y: 30, opacity: 0 }}
                  transition={{
                    duration: 0.5,
                    delay: 0.5 * 2,
                  }}
                  className="pt-5 flex"
                >
                  <div className="pr-5">
                    <a
                      href="https://www.hackerrank.com/anand_a6"
                      target="_blank"
                    >
                      <Icon width="30" name="hackerrank" />
                    </a>
                  </div>
                  {/* <div className='pr-5'>
											<Icon width='33' name='email' />
										</div> */}
                  {/* <div className='pr-5'>
											<Icon width='28' name='whatsapp' />
										</div> */}
                  <div className="pr-5">
                    <a href="https://github.com/anand-ammathil" target="_blank">
                      <Icon width="30" name="github" />
                    </a>
                  </div>
                  <div className="pr-5">
                    <a
                      href="https://www.linkedin.com/in/anand-ammathil/"
                      target="_blank"
                    >
                      <Icon width="28" name="linkedin" />
                    </a>
                  </div>
                  <div className="pr-5">
                    <a
                      href="https://www.instagram.com/anand_ammathil/"
                      target="_blank"
                    >
                      <Icon width="28" name="instagram" />
                    </a>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
        <div
          onClick={() => window.scrollBy(0, 300)}
          className="grid justify-center pt-5 bottom-0"
        >
          <ArrowDown />
        </div>
      </div>
    </div>
  );
};

export default Home;
